import request from '@/utils/request'
// import qs from 'qs'
// 员工基本工资
// 查看所有员工
export const memberList = (postData) => {
  return request({
    url: '/members-wages/queryListProjectMember',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 添加员工的基本工资信息
export const addWages = (postData) => {
  return request({
    url: '/members-wages/saveMemberWages',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 修改员工的基本工资信息
export const updateWages = (postData) => {
  return request({
    url: '/members-wages/updateMemberWages',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 删除员工的基本工资信息
export const deleteWages = (getData) => {
  return request({
    url: '/members-wages/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 分页查看基本信息
export const pageList = (getData) => {
  return request({
    url: '/members-wages/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 批量更新是否参与计算绩效
export const batchUpdatePerformanceCalc = (postData) => {
  return request({
    url: '/members-wages/batchUpdatePerformanceCalc',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
